import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import ImportFileNewTemplatePage, { getDefaultData, getDefaultUI } from "components/pages/ImportFileNewTemplatePage";
import Classes, { ACHTemplate, Company, CompanyAccount } from "model";

/**
 * @name CaptureNewTemplateAllColumnsCompleted
 * @returns {React.Component}
 * @description 
 * This capture is used in the following capture groups:
 * "ACH - ImportFile (Non-NACHA)" (abi22).
 */
export default function CaptureNewTemplateAllColumnsCompleted(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);

    const selectedTemplate = ACHTemplate.init({
        id: ACHTemplate.nextID(),
        transactionType: "payment",
        secCode: "PPD Credit - Consumer Credit",
        name: "SamplePPD",
        companyDiscretionaryData: "",
        companyEntryDescription: "",
        creditAmount: "0.00",
        debitAmount: "0.00",
        achToParticipants: [],
        achFromAccount: [],
        company: Company.initByID(0),
        companyAccount: CompanyAccount.initByID(0),
        numberOfAccounts: "0"
    });

    let selectedColumns = getDefaultData().selectedColumns;
    let mapColumns = getDefaultData().mapColumns;
    
    mapColumns = mapColumns.reduce((acc, item, i) => {
        if(item.isSelected !== undefined && i === 1) {
            item.isSelected = true;
        }
        return [...acc, item]
    }, []);
    
    selectedColumns[0].value = { id: "1", value: "Name (Required)", class: "name" };
    selectedColumns[1].value = { id: "3", value: "Account Number (Required)", class: "account-number", isSelected: false };
    selectedColumns[2].value = { id: "7", value: "Routing Transit (Required)", class: "routing-transit", isSelected: false };
    selectedColumns[3].value = { id: "2", value: "Amount (Required)", class: "amount", isSelected: false };
    selectedColumns[4].value = { id: "4", value: "Transaction Code", class: "transaction-code", isSelected: false };


    const data = BCMSStateManagerCRUD.init(getDefaultData())
    .update([ "template" ], selectedTemplate)
    .update([ "selectedColumns" ], selectedColumns)
    .update([ "mapColumns" ], mapColumns)
    .submit();

    const ui = BCMSStateManagerCRUD.init(getDefaultUI())
    //.update([ "mapColumnSelect2", "isActive" ], true)
    .submit();

    return <ImportFileNewTemplatePage data={ data } ui={ ui } />;
}